// import logo from './logo.svg';
// import './App.css';
import { type FC } from 'react';
import { getAppConfig } from '@/app/config';
import { ProviderTheme } from '@/app/ProviderTheme';
import { ProviderQuery } from '@/app/ProviderQuery';
import { Router } from '@/app/ProviderPage';
import { ProviderConfig } from '@/app/ProviderConfig';
import { ProviderKitchenSink } from './app/ProviderKitchenSink';
import bugsnag from '@/bugsnag';
import ErrorBoundaryView from '@/base/ErrorBoundary/ErrorBoundaryView';
import { HelmetProvider } from 'react-helmet-async';
import { LocaleProvider } from '@/registration/component/Locale/LocaleProvider';

const helmetContext = {};

bugsnag.start();

const App: FC = () => {
  const ErrorBoundary = bugsnag.ErrorBoundary();
  return (
    <HelmetProvider context={helmetContext}>
      <ProviderConfig config={getAppConfig()}>
        <ProviderTheme>
          <ProviderQuery>
            <ProviderKitchenSink>
              <ErrorBoundary FallbackComponent={ErrorBoundaryView}>
                <Router />
              </ErrorBoundary>
            </ProviderKitchenSink>
          </ProviderQuery>
        </ProviderTheme>
      </ProviderConfig>
    </HelmetProvider>
  );
};

export default App;
